import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';

import Button from 'partial/components/Button';
import { useUpdateActiveMaskName } from '../hooks';

export const useOpenActiveMaskName = () => {
  const createModal = useCreateModal();

  const openActiveMaskNameModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <ActiveMaskName data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openActiveMaskNameModal;
};

function ActiveMaskName({ onClose, data }) {
  const label = data?.is_deactivate ? 'ACTIVATE' : 'DEACTIVATE';
  const [isLoading, update] = useUpdateActiveMaskName(onClose);

  const submit = () => {
    update({
      uuid: data?.uuid,
      payload: { is_deactivate: data?.is_deactivate ? 0 : 1 },
    });
  };

  return (
    <ModalCard size="sm" title={`${label} MASK NAME`} onClose={onClose}>
      <div className="p-5 w-full">
        <p className="text-sm font-semibold mb-6">
          Are you sure you want to {label} this mask name
          <span className="text-primary"> {data?.name}</span> for organization
          <span className="text-primary"> {data?.organization_name}</span>?
        </p>
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isLoading}
            outline
            className="uppercase"
            onClick={submit}
          >
            confirm
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

ActiveMaskName.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ActiveMaskName;
